<svg
  xmlns="http://www.w3.org/2000/svg"
  width="53"
  height="60"
  class="user-select-none cursor-pointer"
  fill="none">
  <g filter="url(#a)">
    <path
      fill="#45B36B"
      d="M4.305 2.9a2 2 0 0 1 2-2h34a2 2 0 0 1 2 2v37.552a3 3 0 0 1-1.319
      2.484l-16 10.827a3 3 0 0 1-3.363 0l-16-10.827a3 3 0 0 1-1.318-2.484V2.9Z" />
  </g>
  <defs>
    <filter
      id="a"
      width="46"
      height="61.378"
      x=".305"
      y=".901"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="2" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
      <feBlend
        in2="BackgroundImageFix"
        result="effect1_dropShadow_4061_189323" />
      <feBlend
        in="SourceGraphic"
        in2="effect1_dropShadow_4061_189323"
        result="shape" />
    </filter>
  </defs>
</svg>
